import { useCircleSize } from "arkh";
import React from "react";
import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";
import { TodoListItemMainContentDetails_todo$key } from "./__generated__/TodoListItemMainContentDetails_todo.graphql";
import { TodoListItemImages } from "./TodoListItemImages";
import { TodoListItemCompletedInfo } from "./TodoListItemCompletedInfo";

export function TodoListItemMainContentDetails(props: {
  todo: TodoListItemMainContentDetails_todo$key;
}) {
  const smallMedium = useCircleSize("smallMedium");
  const todo = useFragment(
    graphql`
      fragment TodoListItemMainContentDetails_todo on Todo {
        ...TodoListItemCompletedInfo_todo
        status
        images {
          id
          ...Image_image
        }
        linkedProducts {
          imageUrl
        }
      }
    `,
    props.todo
  );

  const images = [
    ...(todo.images?.map((image) => ({
      type: "fragment" as const,
      value: image,
    })) || []),
    ...(todo.linkedProducts?.flatMap(({ imageUrl }) =>
      imageUrl !== null ? [{ type: "url" as const, value: imageUrl }] : []
    ) || []),
  ];

  return todo.status === "DONE" ? (
    <TodoListItemCompletedInfo todo={todo} />
  ) : images.length > 0 ? (
    <TodoListItemImages images={images} size={smallMedium} />
  ) : null;
}
